/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
var o;!function(o){o[o.transform=0]="transform",o[o.fromColor=1]="fromColor",o[o.toColor=2]="toColor",o[o.colorMix=3]="colorMix",o[o.toOpacity=4]="toOpacity",o[o.opacityMix=5]="opacityMix"}(o||(o={}));export{o as AnimationParamIndex};
